import type { BoxProps } from '@customerio/pluma-components/react';
import { Box, Text } from '@customerio/pluma-components/react';
import * as styles from './index.css';

export function ShimmerText({ children, ...rest }: { children: React.ReactNode } & BoxProps) {
  return (
    <Box {...rest}>
      <Text className={styles.shimmerText}>{children}</Text>
    </Box>
  );
}
